export enum ApiMethod {
    GET = "GET",
    POST = "POST",
    DELETE = "DELETE",
}

export type QueryParam = {
    key: string;
    value: string;
};

export enum ApiResponseType {
    OK = "OK",
    FORM_INVALID = "FORM_INVALID",
    CLIENT_ERROR = "CLIENT_ERROR",
    SERVER_ERROR = "SERVER_ERROR",
}